<template>
  <fade-transition :theme="theme">
    <div
         class="west-block"
        :style="{ 'width': width, 'min-width': minWidth }">
        <div class="west-slide-component-wrap">
          <div class="component-wrap-nav">
            <div class="wrap-nav__top">
              <slot name="navigation-top"></slot>
            </div>
            <div class="wrap-nav__bottom">
              <slot name="navigation-bottom"></slot>
            </div>
          </div>
          <div class="component-wrap-content">
            <slot></slot>
          </div>
        </div>
      </div>
  </fade-transition>
</template>

<script>
import FadeTransition from 'components/ui/transitions/fade-transition';

export default {
  name: 'nuttrema-layout-west-slide',
  props: {
    width: {
      type: String,
      required: false,
      default: '25%',
    },
    minWidth: {
      type: String,
      required: false,
      default: '35em',
    },
    left: {
      type: String,
      required: false,
      default: '64px',
    },
    transition: {
      type: String,
      required: false,
      default: null,
    },
    parentTransition: {
      type: String,
      required: false,
      default: null,
    },
    theme: {
      type: String,
      required: false,
      default: null,
    },
  },
  components: {
    FadeTransition,
  },
};
</script>

<style lang="scss" scoped>
  .west-block {
    left: 0;
    bottom: 0;
    height: 100%;
    position: absolute;
    animation: anim 0.25s;
    -webkit-animation: anim 0.25s;

    &.go-out {
      animation: anim-reverse 0.25s;
      -webkit-animation: anim-reverse 0.25s;
    }

    .west-slide-component-wrap {
      flex-grow: 1;
      height: 100%;
      display: flex;
      align-self: stretch;
      .component-wrap-nav {
        z-index: 11;
        display: flex;
        flex: 0 1 64px;
        min-width: 64px;
        flex-direction: column;
        background-color: #c8d0e1;
        justify-content: space-between;
        .wrap-nav__top {
          display: flex;
        }
        .wrap-nav__bottom {
          display: flex;
          justify-content: center;
        }
      }
      .component-wrap-content {
        flex-grow: 1;
        display: flex;
        overflow: hidden;
        position: relative;
        background-color: #fff;
      }
    }

  }

  .theme-is-dark {
    .west-block {
      .west-slide-component-wrap {
        .component-wrap-nav {
          background-color: rgba(0,0,0, 0.5);
        }
        .component-wrap-content {
          background-color: rgba(0,0,0, 1);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/layout/nuttrema-layout-west-slide.vue